module.exports = __webpack_public_path__ + "media/images/icons/ic-dropdown-arrow-green-e493144eef3759a9593783c3e2b79a82.svg";